module.exports = __webpack_public_path__ + "static/media/mudey_rating3.b4b2bb6f.svg";